import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('menu', [
      'getMenuName',
    ]),
    menuHeaderName() {
      const nameByPath = this.getMenuName(this.$route.path)
        ? this.getMenuName(this.$route.path).name
        : '';

      const nameByName = this.getMenuName(this.$route.name)
        ? this.getMenuName(this.$route.name).name
        : '';

      return nameByPath || nameByName;
    },
    headerTitle() {
      const i18nName = this.menuHeaderName.startsWith('page.') || this.menuHeaderName.startsWith('menuItems.');

      const nameByTitle = i18nName
        ? this.$t(this.menuHeaderName)
        : this.menuHeaderName;

      return this.$t(this.$route.meta.pageName)
        ? this.$t(this.$route.meta.pageName)
        : nameByTitle;
    },
  },
};
